<template>
    <div class="language">
        <!-- Currently selected language -->
        <div
            @click="langClicked = !langClicked"
            class="current"
            :class="{ active : langClicked === true }"
        >
            {{ currentLang.toUpperCase() }}
        </div>

        <!-- List of available languages -->
        <ul  v-if="langClicked" class="list" data-name="language-list">
            <li
                class="item"
                v-for="language in languages"
                :data-name="language.locale"
                @click="switchLang(language.locale)"
                :class="{ active : language.locale === currentLang }"
            >
                {{ language.name }}
            </li>
        </ul>

    </div>
</template>


<script>
    export default {


        data() {
            return {
                currentLang: document.getElementsByTagName('html')[0].getAttribute('lang'),
                languages: [
                    { locale: 'en', name: window.lang.get('components/common/language-switcher.languages.en')},
                    { locale: 'de' , name: window.lang.get('components/common/language-switcher.languages.de')},
                ],
                langClicked: false
            }
        },
        created() {
            const url = new URL(window.location.href);
            const lang = url.searchParams.get("lang");

            if (lang) {
                window.lang.setLocale(lang);
                this.currentLang = lang;
            } else {
                window.lang.setLocale('en');
            }
        },
        methods: {
            switchLang: function(lang) {
                window.location='?lang='+lang;
            },
        },


    }
</script>
